import { Link } from "react-router-dom";

const base = process.env.PUBLIC_URL || "";
const LOGO = `${base}/brand/horizontal.png`;
const LOGO_BYLINE = `${base}/brand/horizontal-byline.png`;

// Official Best Bizz logo. On dark backgrounds (`light`) the navy artwork is
// rendered white via filter, and the byline version is used.
const Logo = ({ light = false, onClick }) => {
  return (
    <Link
      to="/"
      onClick={onClick}
      data-testid="logo-home-link"
      className="inline-flex items-center shrink-0"
      aria-label="Best Bizz Financial & Management Services — Home"
    >
      <img
        src={light ? LOGO_BYLINE : LOGO}
        alt="Best Bizz Financial & Management Services"
        className={
          light
            ? "h-12 w-auto [filter:brightness(0)_invert(1)]"
            : "h-9 sm:h-10 w-auto"
        }
        loading="eager"
      />
    </Link>
  );
};

export default Logo;
